<div class="inicio">
  
  <br>
  <div class="columnas_3">
    <!--BOTÓN ATRÁS-->
    <button mat-mini-fab color="accent" matTooltip="Retornas a ver todas los mantenimeintos" (click)="clickAtras($event)" ><mat-icon style="transform: rotate(180deg);">forward icon</mat-icon></button>
    <!--TITULO-->
    <div><p class="titulo">DETALLE REGISTRO MANTENIMIENTO</p></div>
  </div>

  <!--DATOS GENERALES-->
  <div class="columnas_3">

    <!--DATOS GENERALES (FECHAS DE AGENDA, REALIZACION Y SUCURSAL)-->
    <div class="columna_1">
      <p class="texto"> FECHA AGENDADA:        {{registro_mantenimiento.fecha_agendad_tabla}}</p>
      <p class="texto"> FECHA DE REALIZACION:  {{fecha_actual}}</p>
      <!--<p class="texto"> SUCURSAL:              {{this.registro_mantenimiento.sucursal_Tabla}}</p>-->
    </div>

    <div class="columna_1__fila1">
      <mat-label class="texto"> Nombre del equipo <mat-label class="advertencia">*</mat-label> </mat-label>
      <mat-form-field class="example-full-width" appearance="fill">
        <input type="text" matInput [formControl]="input___Equipo"  placeholder="Ejem. SOF-GTI-LAP000"  [matAutocomplete]="auto"  oninput="this.value = this.value.toUpperCase()">
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="clickAgregarEquipo($event.option.value)" >
            <mat-option *ngFor="let option of lista_equipos_filtrada | async" [value]="option"> {{option.name}} </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

  </div>

  <!--CUERPO-->
  <div class="columnas_2">

  <!--TABLA DE EQUIPOS-->
  <div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                
      <ng-container matColumnDef="OPCIONES">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
          <button mat-mini-fab color="primary" matTooltip="Click para comenzar a registrar el mantenimeinto a este equipo"  (click)="clickEditar(element)">
              <mat-icon>edit</mat-icon>
          </button>
          <button mat-mini-fab color="warn" matTooltip="Click para remover de la lista de equipos programados" (click)="clickCancelarRegistro(element)">
            <mat-icon>cancel</mat-icon>
        </button>
      </td>
      </ng-container>

      <ng-container matColumnDef="EQUIPO">
        <th mat-header-cell *matHeaderCellDef> EQUIPO </th>
        <td mat-cell *matCellDef="let element"> {{ element.nombre_equipo }} </td>
      </ng-container>


      <ng-container matColumnDef="TIPO DE EQUIPO">
        <th mat-header-cell *matHeaderCellDef> TIPO DE EQUIPO </th>
        <td mat-cell *matCellDef="let element"> {{ element.tipo_activo }} </td>
      </ng-container>

  
      <tr mat-header-row *matHeaderRowDef="encabezados"></tr>
      <tr mat-row *matRowDef="let row; columns: encabezados;"></tr>
    </table>
    <mat-paginator #paginator class="mat-elevation-z8" [pageSize]="10" showFirstLastButtons></mat-paginator>
  </div>

  <!--FORMULARIO-->
  <form #insertForm="ngForm" [formGroup]="formulario">
    
    <div class="columnas_2__filas_7">
      
      <mat-label class="subtitulo">EQUIPO: {{nombre_equipo}} </mat-label>
      <div></div>

      <mat-label class="texto">Tipo de mantenimiento </mat-label>
      <mat-label class="texto">Actividades realizadas</mat-label>
      
      <!--TIPO DE MANTENIMINETO-->
      <mat-form-field appearance="fill">
        <mat-select formControlName="tipo_Mantenim" (selectionChange)="select_Tipo_Man()">
          <mat-option *ngFor="let tipo_man of lista_Tipo_de_Manten" [value]="tipo_man"> {{tipo_man.nombre}} </mat-option>
        </mat-select>
      </mat-form-field>

      <!--ACTIVIDADES-->
      <mat-form-field appearance="fill">
        <mat-select formControlName="actividad_Man" multiple>
          <mat-select-trigger>
            <span *ngIf="formulario.value.actividad_Man?.length > 0" class="example-additional-selection">
              ACTIVIDADES SELECCIONADAS
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let actividad of lista_ActividadesMan" [value]="actividad">{{actividad.nombre_act}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-label class="texto">Comentarios del usuario</mat-label>
      <mat-label class="texto">Observaciones del equipo</mat-label>
      
      <!--OBSERVACIONES-->
      <mat-form-field class="example-full-width" appearance="fill">
        <input matInput formControlName="comentarios_U">
      </mat-form-field>

      <!--COMENTARIOS-->
      <mat-form-field class="example-full-width" appearance="fill">
        <input matInput formControlName="comentarios_U">
      </mat-form-field>

      <!--PROBLEMA O FALLO-->
      
      <mat-label       *ngIf="!verCampoProblema" class="texto">Problema o fallo</mat-label><div></div>
      <mat-form-field  *ngIf="!verCampoProblema" class="example-full-width" appearance="fill">
        <input matInput formControlName="problema_dete">
      </mat-form-field>





      <!--BOTÓN GUARDAR-->
      <div class="example-button-row" style="align-items: center;">
        <button mat-raised-button color="primary" matTooltip="Guarda la información de mantenimiento realizada al equipo" (click)="clickGuardar($event)" [disabled]="!habilitar_Btn_Guardar()" style="margin-bottom: 5%;" > Guardar <mat-icon>save</mat-icon> </button>
      </div>
    </div>
  </form>

  </div>

  <div class="columna_1">

    <mat-label class="texto" >Observaciones generales</mat-label>
    <mat-form-field class="example-full-width" appearance="fill">
      <input matInput [formControl]="input_Observ_G" >
    </mat-form-field>

  </div>

  <!--BOTÓN CANCELAR-->
  <div class="columnas_3_fila_1">
    <button mat-raised-button color="warn"    matTooltip="Marca como cancelado el mantenimiento programado" (click)="clickCancelarMantenimiento($event)" > Cancelar <mat-icon>cancel</mat-icon> </button>
    <div></div>
    <button mat-raised-button color="primary" matTooltip="Finaliza este mantenimiento programado" (click)="clickGuardarRegistro($event)" [disabled]="!validacion_data()"> Guardar <mat-icon>save</mat-icon> </button>
  </div>

</div>